import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { RETRIBUSI, money, number } from "@/data/seed";

const HEAD = ["Tanggal", "Jenis Ikan", "Kapal", "Zona", "Berat (kg)", "Nilai Transaksi (Rp)"];

export const summarize = (catches) => {
  const weight = catches.reduce((a, c) => a + Number(c.weight), 0);
  const value = catches.reduce((a, c) => a + Number(c.value), 0);
  const bySpecies = Object.values(catches.reduce((acc, c) => {
    const s = acc[c.species] || { species: c.species, count: 0, weight: 0, value: 0 };
    s.count += 1; s.weight += Number(c.weight); s.value += Number(c.value);
    acc[c.species] = s;
    return acc;
  }, {})).sort((a, b) => b.weight - a.weight);
  return { weight, value, retribusi: value * RETRIBUSI, bySpecies };
};

export function exportPdf(catches) {
  const s = summarize(catches);
  const doc = new jsPDF({ orientation: "landscape" });
  doc.setFont("helvetica", "bold").setFontSize(16).text("Laporan Produksi Perikanan - SIP-IKAN Pameungpeuk", 14, 16);
  doc.setFont("helvetica", "normal").setFontSize(10).text(`TPI Santolo Pameungpeuk · Dicetak ${new Date().toLocaleDateString("id-ID")}`, 14, 23);
  doc.text(`Total produksi: ${number(s.weight)} kg  |  Nilai: ${money(s.value)}  |  Retribusi 2%: ${money(s.retribusi)}`, 14, 30);
  const style = { headStyles: { fillColor: [30, 62, 98] }, styles: { fontSize: 9 } };
  autoTable(doc, { startY: 36, head: [["Jenis Ikan", "Jumlah Catatan", "Berat (kg)", "Nilai (Rp)"]], body: [...s.bySpecies.map((r) => [r.species, r.count, number(r.weight), money(r.value)]), ["TOTAL", catches.length, number(s.weight), money(s.value)]], ...style });
  autoTable(doc, { startY: doc.lastAutoTable.finalY + 8, head: [HEAD], body: catches.map((c) => [c.date, c.species, c.vessel, c.zone, number(c.weight), money(c.value)]), ...style });
  doc.save("laporan-tangkapan-sip-ikan.pdf");
}

export function exportExcel(catches) {
  const s = summarize(catches);
  const wb = XLSX.utils.book_new();
  const rekap = XLSX.utils.aoa_to_sheet([
    ["Laporan Produksi Perikanan - SIP-IKAN Pameungpeuk"], [],
    ["Jenis Ikan", "Jumlah Catatan", "Berat (kg)", "Nilai (Rp)"],
    ...s.bySpecies.map((r) => [r.species, r.count, r.weight, r.value]),
    ["TOTAL", catches.length, s.weight, s.value], [],
    ["Retribusi TPI (2%)", "", "", s.retribusi]
  ]);
  const detail = XLSX.utils.aoa_to_sheet([HEAD, ...catches.map((c) => [c.date, c.species, c.vessel, c.zone, Number(c.weight), Number(c.value)])]);
  rekap["!cols"] = [{ wch: 26 }, { wch: 16 }, { wch: 14 }, { wch: 18 }];
  detail["!cols"] = [{ wch: 14 }, { wch: 20 }, { wch: 20 }, { wch: 14 }, { wch: 12 }, { wch: 20 }];
  XLSX.utils.book_append_sheet(wb, rekap, "Rekap");
  XLSX.utils.book_append_sheet(wb, detail, "Detail");
  XLSX.writeFile(wb, "laporan-tangkapan-sip-ikan.xlsx");
}
